import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Autoplay, Navigation, Pagination, A11y } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"

import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/scrollbar"

const Slidernoticias = props => {
  const query = useStaticQuery(graphql`
    query Noticiashome {
      allStrapiNoticias {
        edges {
          node {
            Titulo
            Enlace_hashtag
            Enlace_hashtag_secundario
            id
            Titulo_dos
            tipo
            hashtag
            hashtag_secundario
            Categoria
            Contenido
            Site
            Imagen {
              url
            }
          }
        }
      }
    }
  `)

  const projects = query.allStrapiNoticias.edges
  let url_global = process.env.GATSBY_API_URL

  return (
    <>
      <div className="container mx-auto px-14 py-1 lg:grid grid-cols-4 gap-4">
        <div
          style={{ maxHeight: "26rem" }}
          className="ancho_primer_noticia col-span-2 shadow-md hover:grow hover:shadow-lg"
          tabIndex="1"
        >
          <Swiper
            centeredSlides={true}
            spaceBetween={30}
            // autoplay={{
            // delay: 6000,
            //disableOnInteraction: true,
            // }}
            style={{ zIndex: "0", height: "100%" }}
            className="slide_noticias_sm"
            slidesPerView="auto"
            pagination={{
              clickable: true,
            }}
            navigation={false}
            modules={[Autoplay, Pagination, Navigation, A11y]}
          >
            {projects.map(({ node: project }, index) => {
              if (project.tipo === "Principal" && project.Site === props.site) {
                return (
                  <SwiperSlide key={index}>
                    <img
                      className="ancho_primera_noticia w-screen object-cover md:h-full"
                      src={url_global + project.Imagen[0].url}
                      alt={project.Titulo}
                      title={project.Titulo}
                    />

                    <div
                      style={{
                        position: "absolute",
                        marginBottom: "4rem",
                        bottom: "0rem",
                      }}
                      className="w-full h-full ubicar_cuadro_contenido_primer_noticia"
                    >
                      <div
                        style={{
                          position: "relative",
                          left: "25rem",
                          bottom: "-23rem",
                          width: "5rem",
                          height: "5rem",
                          zIndex: "1",
                        }}
                        tabIndex="1"
                        className="boton_mas_primer_noticia rounded-full border border-white p-3"
                      >
                        <a
                          tabIndex="1"
                          href={"/personas/detallenoticias/?id=" + project.id}
                        >
                          <button
                            style={{
                              width: "3rem",
                              height: "3rem",
                              marginLeft: "3px",
                              marginTop: "3px",
                            }}
                            className="circulo_interno_boton_primer_noticia p-0 w-10 h-10 bg-white rounded-full hover:bg-gray-50 active:shadow-lg mouse shadow transition ease-in duration-200 focus:outline-none"
                          >
                            <svg
                              viewBox="0 0 20 20"
                              enableBackground="new 0 0 20 20"
                              className="imagen_mas_boton_primer_noticia w-6 h-6 inline-block"
                            >
                              <path
                                fill="#707070"
                                d="M16,10c0,0.553-0.048,1-0.601,1H11v4.399C11,15.951,10.553,16,10,16c-0.553,0-1-0.049-1-0.601V11H4.601 C4.049,11,4,10.553,4,10c0-0.553,0.049-1,0.601-1H9V4.601C9,4.048,9.447,4,10,4c0.553,0,1,0.048,1,0.601V9h4.399 C15.952,9,16,9.447,16,10z"
                              />
                            </svg>
                          </button>
                        </a>
                      </div>

                      <div className="p-8 hidden md:block" tabIndex="1">
                        <p
                          style={{ fontSize: "14px" }}
                          style={{
                            lineHeight: "1.3rem",
                            width: "13rem",
                            color: "#064e3b",
                          }}
                          className="relative mitexto_color tamano_primer_noticia_texto mt-2 text-slate-500 text-poppins-bold color-texto-parrafo"
                        >
                          {" "}
                          {project.Titulo}
                        </p>
                      </div>

                      <div className="p-8 hidden md:block" tabIndex="1">
                        <p
                          style={{
                            width: "14rem",
                            fontSize: "14px",
                          }}
                          className="relative alinear_segundo_texto_noticia mt-2 text-slate-500 text-poppins-bold color-texto-parrafo"
                        >
                          {" "}
                          {project.Titulo_dos}
                        </p>
                      </div>

                      <div className="p-8 hidden md:block relative tamano_tituilo_tercer_texto_noticia tracking-wide text-sm text-indigo-500 font-semibold">
                        <a
                          style={{ fontSize: "14px" }}
                          href={project.Enlace_hashtag}
                          className="block mt-5 text-lg leading-tight text-poppins-bold color-texto-parrafo font-medium hover:underline"
                          tabIndex="1"
                        >
                          {project.hashtag}
                        </a>

                        <a
                          style={{ fontSize: "14px" }}
                          href={project.Enlace_hashtag_secundario}
                          className=" block text-lg leading-tight text-poppins-bold color-texto-parrafo font-medium hover:underline"
                          tabIndex="1"
                        >
                          {project.hashtag_secundario}
                        </a>
                      </div>

                      {/* MOBILE */}
                      <div className="p-8  titulo_uno_noticia_movil md:hidden lg:hidden xl:hidden 2xl:hidden">
                        <p
                          style={{ fontSize: "14px" }}
                          style={{
                            lineHeight: "1.3rem",
                            width: "13rem",
                            color: "#064e3b",
                          }}
                          className="relative tamano_primer_noticia_texto mt-2 text-slate-500 text-poppins-bold color-texto-parrafo"
                        >
                          {" "}
                          {project.Titulo}
                        </p>
                      </div>

                      <div className="p-8 relative noticia_titulo_movil md:hidden lg:hidden xl:hidden 2xl:hidden">
                        <p
                          style={{
                            color: "#707070",
                            width: "8rem",
                            fontSize: "14px",
                          }}
                          className="relative mitexto_color alinear_segundo_texto_noticia mt-2 text-slate-500 text-poppins-bold color-texto-parrafo"
                        >
                          {" "}
                          {project.Titulo_dos}
                        </p>
                      </div>

                      <div className="p-8 md:hidden lg:hidden xl:hidden 2xl:hidden relative tamano_tituilo_tercer_texto_noticia tracking-wide text-sm text-indigo-500 font-semibold">
                        <a
                          style={{ fontSize: "14px", color: "#707070" }}
                          href={project.Enlace_hashtag}
                          className="mitexto_color block mt-5 text-lg leading-tight text-poppins-bold color-texto-parrafo font-medium hover:underline"
                        >
                          {project.hashtag}
                        </a>

                        <a
                          style={{ fontSize: "14px", color: "#707070" }}
                          href={project.Enlace_hashtag_secundario}
                          className="mitexto_color block text-lg leading-tight text-poppins-bold color-texto-parrafo font-medium hover:underline"
                        >
                          {project.hashtag_secundario}
                        </a>
                      </div>

                      {/* TERMINA EL MOBILE */}
                    </div>
                  </SwiperSlide>
                )
              }
            })}
          </Swiper>
        </div>

        {projects.map(({ node: noticia_dos }, i) => {
          if (
            noticia_dos.tipo === "Secundario" &&
            noticia_dos.Site === props.site &&
            noticia_dos.Enlace_hashtag !== null &&
            noticia_dos.Imagen[0]?.url !== undefined
          ) {
            return (
              <div
                id="tamano_segundo_noticia"
                className="tamano_segundo_noticia shadow-md hover:grow hover:shadow-lg"
                key={`n-${i}`}
                tabIndex="1"
              >
                <div className="mx-auto mitexto bg-white flex items-center justify-end">
                  <div className="inline-grid grid-cols-1">
                    <div className="h-52 bg-green-hover p-8 texto_oculto_noticia w-full hidden md:shrink-0">
                      <div className="relative text-poppins-regular text-xl mb-2 text-white">
                        <p
                          className="mitexto_color text-poppins-bold segundo_noticia_titulo"
                          style={{ fontSize: "14px" }}
                        >
                          {" "}
                          {noticia_dos.Titulo}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="md:shrink-0" tabIndex="1">
                      <img
                        src={url_global + noticia_dos.Imagen[0]?.url}
                        alt={noticia_dos.Titulo}
                        title={noticia_dos.Titulo}
                        className="imagen_oculta  w-screen object-cover md:h-full"
                      />
                      <div className="flex justify-end mr-4">
                        <div className="absolute items-center flex -mt-10 w-20 h-20 z-10 rounded-full border border-white p-4">
                          <a
                            tabIndex="1"
                            href={
                              "/personas/detallenoticias/?id=" + noticia_dos.id
                            }
                          >
                            <button className="p-0 w-12 h-12 bg-white rounded-full hover:bg-gray-50 active:shadow-lg mouse shadow transition ease-in duration-200 focus:outline-none">
                              <svg
                                viewBox="0 0 20 20"
                                enableBackground="new 0 0 20 20"
                                className="imagen_mas_boton_primer_noticia w-6 h-6 inline-block"
                              >
                                <path
                                  fill="#707070"
                                  d="M16,10c0,0.553-0.048,1-0.601,1H11v4.399C11,15.951,10.553,16,10,16c-0.553,0-1-0.049-1-0.601V11H4.601 C4.049,11,4,10.553,4,10c0-0.553,0.049-1,0.601-1H9V4.601C9,4.048,9.447,4,10,4c0.553,0,1,0.048,1,0.601V9h4.399 C15.952,9,16,9.447,16,10z"
                                />
                              </svg>
                            </button>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="p-8" tabIndex="1">
                      <p
                        style={{ fontSize: "14px" }}
                        className="mitexto mitexto_color mt-2 text-slate-500 text-poppins-regular color-texto-parrafo"
                      >
                        {" "}
                        {noticia_dos.Titulo_dos}
                      </p>
                      <div className="tracking-wide text-sm text-indigo-500 font-semibold">
                        <a
                          style={{ fontSize: "14px" }}
                          href={noticia_dos.Enlace_hashtag}
                          className="mitexto mitexto_color block mt-5 text-lg leading-tight text-poppins-bold color-texto-parrafo font-medium hover:underline"
                        >
                          {noticia_dos.hashtag}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        })}

        {projects.map(({ node: noticia_tres }, i) => {
          if (
            noticia_tres.tipo === "Secundario" &&
            noticia_tres.Site === props.site &&
            noticia_tres.Imagen[0]?.url &&
            noticia_tres.Enlace_hashtag_secundario === null &&
            noticia_tres.Enlace_hashtag === null
          ) {
            return (
              <div
                className="tamano_tercera_noticia shadow-md hover:grow hover:shadow-lg"
                key={`n2-${i}`}
                tabIndex="1"
              >
                <div className="mx-auto mitexto bg-white flex items-center justify-end">
                  <div className="inline-grid grid-cols-1">
                    <div className="h-52 bg-green-hover p-8 texto_oculto_noticia_dos w-full hidden md:shrink-0">
                      <div className="relative text-poppins-regular text-xl mb-2 text-white">
                        <p className="mitexto_color text-poppins-bold segundo_noticia_titulo">
                          {" "}
                          {noticia_tres.Titulo}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="md:shrink-0" tabIndex="1">
                      <img
                        src={url_global + noticia_tres.Imagen[0]?.url}
                        alt={noticia_tres.Titulo}
                        title={noticia_tres.Titulo}
                        className="imagen_oculta_dos w-screen object-cover md:h-full"
                      />
                      <div className="flex justify-end mr-4">
                        <div className="absolute items-center flex -mt-10 w-20 h-20 z-10 rounded-full border border-white p-4">
                          <a
                            tabIndex="1"
                            href={
                              "/personas/detallenoticias/?id=" + noticia_tres.id
                            }
                          >
                            <button className="p-0 w-12 h-12 bg-white rounded-full hover:bg-gray-50 active:shadow-lg mouse shadow transition ease-in duration-200 focus:outline-none">
                              <svg
                                viewBox="0 0 20 20"
                                enableBackground="new 0 0 20 20"
                                className="imagen_mas_boton_primer_noticia w-6 h-6 inline-block"
                              >
                                <path
                                  fill="#707070"
                                  d="M16,10c0,0.553-0.048,1-0.601,1H11v4.399C11,15.951,10.553,16,10,16c-0.553,0-1-0.049-1-0.601V11H4.601 C4.049,11,4,10.553,4,10c0-0.553,0.049-1,0.601-1H9V4.601C9,4.048,9.447,4,10,4c0.553,0,1,0.048,1,0.601V9h4.399 C15.952,9,16,9.447,16,10z"
                                />
                              </svg>
                            </button>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="p-8">
                      <p
                        style={{ fontSize: "14px" }}
                        className="mitexto mitexto_color text-poppins-regular color-texto-parrafo mt-2 text-slate-500"
                      >
                        {" "}
                        {noticia_tres.Titulo_dos}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        })}
      </div>

      <div className="espacio_entre_sesiones container mx-auto grid justify-items-end py-4 pr-16">
        <a
          tabIndex="1"
          href={"/personas/noticias"}
          style={{ fontSize: "1.5rem" }}
          className="alinear_texto_principal_noticias transform hover:-translate-y-1 hover:scale-110 transition duration-500 text-poppins-black-italic inline-block leading-relaxed text-black text-lg"
        >
          {" "}
          <span className="mitexto mitexto_color" style={{ color: "#248443" }}>
            +
          </span>
          <span className="mitexto mitexto_color text-green-light">
            Noticias
          </span>
        </a>
      </div>
    </>
  )
}
Slidernoticias.propTypes = {
  siteTitle: PropTypes.string,
}

Slidernoticias.defaultProps = {
  siteTitle: ``,
}

export default Slidernoticias
